<template lang="pug">
    import-layout
      v-layout.header-title(align-center justify-start row fill-height)
        span.title-bar.header {{title}}
        v-btn.ma-0(icon flat color="primary" @click="openHelpDialog")
          v-icon help_outline
      v-layout(:class="stepContainerClasses")
        step-upload(v-if="stepOne" @click:next="nextStep" @uploaded="nextStep")
        step-configuration(v-if="stepTwo" @click:prev="previousStep" @startImport="handleEndProcess")
      import-help-dialogs(v-model="showHelpDialog" :step="stepNumber")
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import ImportLayout from '@/Contacts/components/import/Layout';
import StepUpload from '@/Contacts/components/import/components/StepUpload';
import StepConfiguration from '@/Contacts/components/import/components/StepConfiguration';
import ImportHelpDialogs from '@/Contacts/components/import/components/ImportHelpDialogs';
import { STEPS } from './config/new-flow';


export default {
  components: {
    ImportLayout,
    StepUpload,
    StepConfiguration,
    ImportHelpDialogs,
  },
  async created() {
    if (!this.tags.length) {
      this.findTags();
    }

    if (!this.customFieldTypes.length) {
      this.findCustomFieldTypes();
    }

    if (!this.customFieldsWithTypes.length) {
      this.findCustomFields();
    }
  },
  data() {
    return {
      steps: STEPS,
      step: 0,
      showHelpDialog: false,
    };
  },
  computed: {
    ...mapState('contact', ['tags']),
    ...mapState('customFields', ['customFieldTypes']),
    ...mapGetters('contactsTable', ['customFieldsWithTypes']),
    currentStep() {
      return this.steps[this.step];
    },
    stepTitle() {
      return this.currentStep.title;
    },
    stepNumber() {
      return this.currentStep.step;
    },
    title() {
      return `Step ${this.stepNumber}: ${this.stepTitle}`;
    },
    stepOne() {
      return this.step === 0;
    },
    stepTwo() {
      return this.step === 1;
    },
    stepContainerClasses() {
      return {
        'mt-4': this.stepOne,
      };
    },
  },
  methods: {
    ...mapActions('contact', ['findTags']),
    ...mapActions('customFields', ['findCustomFieldTypes']),
    ...mapActions('contactsTable', ['findCustomFields']),
    ...mapMutations('importFile', ['clearMessages']),
    nextStep() {
      this.step++;
    },
    previousStep() {
      this.step--;
    },
    handleEndProcess() {
      this.clearMessages();
      this.$router.push('/contacts/import/reporting?new-import=true');
    },
    openHelpDialog() {
      this.showHelpDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 20px;
}
.help {
  color: var(--v-primary-base);
}

.help:hover {
  color: var(--color-hover);
}
</style>
